import React from "react";
import { Link } from "react-router-dom";
import bg21 from "../../assets/images/background/bg-21.png";
import bg9 from "../../assets/images/background/bg-9.png";
import teamone from "../../assets/images/resource/team-1.jpg";
import teamtwo from "../../assets/images/resource/cheff-2.png";
import teamthree from "../../assets/images/resource/team-3.jpg";
import teamfour from "../../assets/images/resource/team-emily.jpg";
import teamfive from "../../assets/images/resource/team-suzzane.jpg";

function Teem() {
    return (
        <>
            <section className="team-section">
                {/* <div className="left-bg"><img src={bg21} alt="" title="" /></div>
                <div className="right-bg"><img src={bg9} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle">
                            <span>experienced team</span>
                        </div>

                        <div className="pattern-image">
                            <img
                                src={
                                    require("../../assets/images/icons/separator.svg")
                                        .default
                                }
                                alt="mySvgImage"
                            />
                        </div>

                        <h2>Meet Our Team</h2>
                    </div>
                    <div className="row justify-content-center clearfix">
                        <div className="team-block col-lg-4 col-md-6 col-sm-12">
                            <div
                                className="inner-box wow fadeInUp"
                                data-wow-duration="1500ms"
                                data-wow-delay="0ms"
                            >
                                <div className="image">
                                    <img src={teamone} alt="" />
                                    <div className="overlay-box">
                                        <div className="overlay-inner">
                                        </div>
                                    </div>
                                </div>
                                <h3>
                                    <Link to="#">Sylvie</Link>
                                </h3>
                                <div className="designation">
                                    Owner
                                </div>
                                <div className="text desc">
                                    Loving mother of 5 and grandmother of 5, she
                                    is always thinking of her family that
                                    extends to our loyal, local customers. She
                                    loves to make art and dance.
                                </div>
                            </div>
                        </div>

                        <div className="team-block col-lg-4 col-md-6 col-sm-12">
                            <div
                                className="inner-box wow fadeInUp"
                                data-wow-duration="1500ms"
                                data-wow-delay="300ms"
                            >
                                <div className="image">
                                    <img src={teamtwo} alt="" />
                                    <div className="overlay-box">
                                        <div className="overlay-inner">
                                        </div>
                                    </div>
                                </div>
                                <h3>
                                    <Link to="#">Jean François</Link>
                                </h3>
                                <div className="designation">Owner & Chef</div>
                                <div className="text desc">
                                    Loving father of 5 and grandfather of 5,
                                    François has a passion for bringing people
                                    together with food. He loves to golf and do
                                    hot yoga.
                                </div>
                            </div>
                        </div>

                        <div className="team-block col-lg-4 col-md-6 col-sm-12">
                            <div
                                className="inner-box wow fadeInUp"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="image">
                                    <img src={teamfive} alt="" />
                                    <div className="overlay-box">
                                        <div className="overlay-inner">
                                        </div>
                                    </div>
                                </div>
                                <h3>
                                    <Link to="#">Suzanne</Link>
                                </h3>
                                <div className="designation">Administrator</div>
                                <div className="text desc">As Administrator, Suzanne keeps Chez François running smoothly behind the scenes, managing payroll, office relations, and reservations for large groups and private functions.</div>
                            </div>
                        </div>

                        <div className="team-block col-lg-4 col-md-6 col-sm-12">
                            <div
                                className="inner-box wow fadeInUp"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="image">
                                    <img src={teamfour} alt="" />
                                    <div className="overlay-box">
                                        <div className="overlay-inner">
                                        </div>
                                    </div>
                                </div>
                                <h3>
                                    <Link to="#">Emily</Link>
                                </h3>
                                <div className="designation">Front of house Manager</div>
                                <div className="text desc">Our Front of House Manager Emily ensures a warm welcome, smooth service, and exceptional dining experiences at Chez François.</div>
                            </div>
                        </div>

                        <div className="team-block col-lg-4 col-md-6 col-sm-12">
                            <div
                                className="inner-box wow fadeInUp"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="image">
                                    <img src={teamthree} alt="" />
                                    <div className="overlay-box">
                                        <div className="overlay-inner">
                                        </div>
                                    </div>
                                </div>
                                <h3>
                                    <Link to="#">Dominik</Link>
                                </h3>
                                <div className="designation">Owner</div>
                                <div className="text desc">Dominik, the owner, has taken the reins of his parents’ business and oversees daily operations. He is hands-on with large groups and private functions, ensuring every guest enjoys an exceptional experience.</div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
}

export default Teem;
